import { sanitizedStringEquals } from "@recharge";

import { ProductTitle } from "../types/products";

/** @returns the given string converted to a ProductTitle or undefined if it's not a known ProductTitle */
export function normalizeProductTitle(
  toNormalize: string,
): ProductTitle | undefined {
  const withoutExtraRechargeStuff = toNormalize
    .replace(/\s*\(Ships every \d+ Days?\)\s*/gi, "");
  return Object.values(ProductTitle)
    .find((pt) => sanitizedStringEquals(withoutExtraRechargeStuff, pt, true));
}
